import { tools } from "../data/appCatalog.js";
import { useI18n } from "../i18n.jsx";

export default function ToolTabs({ level, currentToolId, navigate }) {
  const { t } = useI18n();

  return (
    <nav className="tool-tabs" aria-label={t(level.toolsLabelKey, {}, `${level.label} tools`)}>
      {level.tools.map((toolId) => (
        <button
          className={currentToolId === toolId ? "tool-tab is-active" : "tool-tab"}
          key={toolId}
          type="button"
          style={{
            "--tab-accent": tools[toolId].accent,
            "--tab-accent-strong": tools[toolId].accentStrong,
            "--tab-soft": tools[toolId].soft,
            "--tab-ring": tools[toolId].ring
          }}
          onClick={() => navigate(`/${level.id}/${toolId}`)}
        >
          {t(tools[toolId].labelKey, {}, tools[toolId].label)}
        </button>
      ))}
    </nav>
  );
}
